import { render, staticRenderFns } from "./merchantadd.vue?vue&type=template&id=3e1aba1c&scoped=true"
import script from "./merchantadd.vue?vue&type=script&lang=js"
export * from "./merchantadd.vue?vue&type=script&lang=js"
import style0 from "./merchantadd.vue?vue&type=style&index=0&id=3e1aba1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1aba1c",
  null
  
)

export default component.exports